<template>
  <div>
    <div v-if="$route.path.indexOf('_edit') === -1">
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="toAdd()" size="mini">新增加价规则+</el-button>
      </el-col>
    </el-row>
    <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column  label="状态">
        <template slot-scope="scope">
          <el-tag type="success" size="mini"  v-if="scope.row.status == true" >启用</el-tag>
          <el-tag type="default" size="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>
       <el-table-column  label="操作">
          <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.row.id)">编辑</el-button>
          </template>
       </el-table-column>
    </el-table>
    <div class="content-center content-top-padded">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50]"
        :total="total_count"
        :page-size="params.pagesize"
      >
      </el-pagination>
    </div>
  </div>
   <router-view></router-view>
  </div>
</template><script>
import { mapGetters } from "vuex";
import {
  getMerchantFreight,
  delMerchantFreight,
} from "../../../api/merchant";

export default {
  components: {},
  data() {
    return {
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
      },
      dataList: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    toAdd() {
      this.$router.push({ path: this.matchHidePage("edit") });
    },
    edit(id) {
      this.$router.push({
        path: this.matchHidePage("edit"),
        query: { id: id },
      });
    },
     del(id, index) {
      var that = this;
      this.$confirm("确定要删除该商品？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delMerchantFreight(id).then((res) => {
              if (res.status) {
                this.$message({
                  message: "已删除",
                  type: "success",
                  duration: 2000,
                });
                setTimeout(function () {
                  that.dataList.splice(index, 1);
                }, 1000);
              }
            });
          }
          done();
        },
      });
    },
    getDataList() {
      this.loading = true;
      getMerchantFreight(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
    //导出预留
    exportData() {
      this.$message({
        type: "success",
        message: "待开发!",
      });
    },
  },
  mounted() {
    this.getDataList();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
.service-label .el-checkbox:first-child {
  margin-left: 15px;
}
.service-label .el-input:first-child {
  margin-left: 15px;
}
.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.el-carousel {
  width: 375px;
}
.grid-detail {
  table,
  .detail-content-wrap,
  .detail-content-item {
    width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?5ce68a22